import { _fetch as fetchSecure } from '@hobs/utils/fetch';

import {
  list,
  CREATE,
} from '@hobs/constants/activity';
import { actionCreator } from '@hobs/actions/utils/utils';

export function getActivities() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('StatementOfRequirements/Activities')
      .then(response => {
        if (response) {
          dispatch(success(response.payload));

          return { success: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: list.REQUEST };
  }
  function success(annexes) {
    return { type: list.SUCCESS, annexes };
  }
  function failure(error) {
    return { type: list.FAILURE, error };
  }
}

export const createActivity = body =>
  actionCreator('StatementOfRequirements/Activities', CREATE, {
    body: body,
    method: 'POST'
  });
